import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/app/consultation-booking/components/ConsultationBookingInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/components/common/Header.tsx");
